import { Component, Input } from '@angular/core';
import { JobProduct } from '../../../../Jobbing/models/JobProduct';
import { Job } from '../../../../Jobbing/models/Job';
import { JobTypeEnum } from '../../../../Jobbing/models/JobTypeEnum';
import { BillingUomEnum } from '../../../../Jobbing/enums/BillingUomEnum';

@Component({
  selector: 'app-job-product-details-box',
  standalone: true,
  imports: [],
  templateUrl: './job-product-details-box.component.html',
  styleUrl: './job-product-details-box.component.scss'
})
export class JobProductDetailsBoxComponent {
  @Input()
  jobDetails?: Job;

  @Input()
  jobProducts?: JobProduct[];

  isContractJob(): boolean {
    if (this.jobDetails && this.jobDetails.jobType && this.jobDetails.jobType === JobTypeEnum.Contract) {
      return true;
    }
    return false;
  }

  getContractUom(): string {
    if (this.jobDetails && this.jobDetails.contractUom) {
      if (this.jobDetails.contractUom === BillingUomEnum.Weight) {
        return 'Weight (tonne)';
      } else if (this.jobDetails.contractUom === BillingUomEnum.Volume) {
        return 'Volume'
      } else if (this.jobDetails.contractUom === BillingUomEnum.Units) {
        return 'Units/Each'
      }
    }
    return '';
  }
}
